export default "__VITE_ASSET__bb241743__"